import React, { Component } from 'react';
import dayjs from 'dayjs';

import services from '@C/CreditCustomerProfile/_utils/data';
import { ProductList, VehicleList } from '@C/CreditCustomers/_utils/';
import { TableGrid } from '@C/TableGrid';
import { DateRangeFilter } from '@C/Utils';
import DropLoaderLarge from '@C/Utils/DropLoaderLarge';
import { authService } from '@S';

const col = [
  {
    name: 'Date',
    key: 'time_stamp',
    sortable: true,
    type: 'date',
  },
  {
    name: 'Slip',
    key: 'credit_slip',
    formatter(props) {
      return <>{props.slip_number}</>;
    },
  },
  {
    name: 'Staff',
    key: 'cashier',
    formatter(props) {
      return (
        <>
          {props.first_name} {props.last_name}
        </>
      );
    },
  },
  {
    name: 'Customer',
    key: 'customer',
    formatter(props) {
      return (
        <>
          {props.first_name} {props.last_name}
        </>
      );
    },
  },
  {
    name: 'Vehicle',
    key: 'credit_slip',
    formatter(props) {
      return <>{props.vehicle_number || '----'}</>;
    },
  },
  {
    name: 'Product',
    key: 'credit_slip',
    formatter(props) {
      return <>{props.product.product}</>;
    },
  },
  {
    name: 'Rate',
    key: 'credit_slip',
    formatter(props) {
      return <>{props.product.price}</>;
    },
  },
  {
    name: 'Qty',
    key: 'quantity',
  },
  {
    name: 'Amount',
    key: 'amount',
  },
  {
    name: 'Amt received',
    key: 'amount_received',
  },
  {
    name: 'Balance',
    key: 'balance',
  },
];

class CreditLedger extends Component {
  constructor(props) {
    super(props);
    this.state = {
      slipList: [],
      selectedId: '',
      showModal: false,
      staff_id: '',
      start_date: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
      end_date: dayjs().format('YYYY-MM-DD'),
      product_id: '',
      customer_id: authService.currentUserId,
      slip_no: '',
      vehicle_number: '',
      loading: false,
      productList: this.props.products,
      customerList: this.props.customers,
      limit: 20,
      offset: 1,
      count: 0,
    };
    this.limitInput = React.createRef();
  }

  componentDidMount() {
    this.getCreditLedger();
  }

  handleQuickSearch = (e) => {
    e.preventDefault();
    if (
      this.limitInput.current.value === '' ||
      this.limitInput.current.value === '0'
    ) {
      return;
    }
    this.setState(
      { limit: this.limitInput.current.value, offset: 1 },
      function () {
        this.getCreditLedger();
      },
    );
  };

  getCreditLedger = () => {
    services
      .getCreditLedger(this.state)
      .then((response) => {
        this.setState({
          slipList: response.data.data.results,
          count: response.data.data.count,
          loading: false,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleDateChange = (e) => {
    if (Array.isArray(e)) {
      const [start_date, end_date] = e;

      this.setState({
        start_date: start_date || '',
        end_date: end_date || '',
      });
      return;
    }

    const { name, value } = e.target;
    const { start_date, end_date } = this.state;

    let newStart = start_date;
    let newEnd = end_date;

    if (name === 'start_date') {
      newStart = value;
      const maxEnd = dayjs(value).add(6, 'month');

      // If current end date is before start or beyond 6 months, adjust it
      if (dayjs(end_date).isBefore(value) || dayjs(end_date).isAfter(maxEnd)) {
        newEnd = maxEnd.format('YYYY-MM-DD');
      }
    } else if (name === 'end_date') {
      const maxEnd = dayjs(start_date).add(6, 'month');
      newEnd = value;

      // If new end date is before start or exceeds 6-month limit, correct it
      if (dayjs(value).isBefore(start_date)) {
        newStart = value;
      } else if (dayjs(value).isAfter(maxEnd)) {
        newEnd = maxEnd.format('YYYY-MM-DD');
      }
    }

    this.setState({
      start_date: newStart,
      end_date: newEnd,
    });
  };

  handlePagination = (e) => {
    this.setState({ offset: e, loading: true }, function () {
      this.getCreditLedger();
    });
  };

  handleStaffChange = (e) => {
    this.setState({ staff_id: e.value });
  };

  handleVehicleChange = (e) => {
    this.setState({ vehicle_number: e?.value || '' });
  };

  handleBillChange = (e) => {
    this.setState({ slip_no: e.target.value });
  };

  handleProductChange = (e) => {
    this.setState({ product_id: e?.value || '' });
  };

  handleCategoryChange = (e) => {
    this.setState({ customer_id: e });
  };

  resetFilter = () => {
    this.limitInput.current.value = 20;
    this.setState(
      {
        staff_id: '',
        start_date: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
        end_date: dayjs().format('YYYY-MM-DD'),
        product_id: '',
        loading: true,
        slip_number: '',
        vehicle_number: '',
        limit: 20,
        offset: 1,
      },
      function () {
        this.getCreditLedger();
      },
    );
  };

  submitForm = (e) => {
    e.preventDefault();
    this.setState({ loading: true }, function () {
      this.getCreditLedger();
    });
  };

  render() {
    const { slipList } = this.state;

    return (
      <section className="widget full-width list-table inverted">
        <header>
          <h3>Credit Ledger</h3>
        </header>
        <main>
          <div className="table-filters">
            <div className="filter-wrapper">
              <div className="filter-group">
                <label>Date range:</label>
                <DateRangeFilter
                  value={[this.state.start_date, this.state.end_date]}
                  onChange={this.handleDateChange}
                  limit={6}
                />
              </div>
              <div className="filter-group">
                <label>Product:</label>
                <ProductList
                  onProductChange={this.handleProductChange}
                  value={this.state.product_id}
                  options={this.state.productList}
                />
              </div>
              <div className="filter-group">
                <label>Vehicle:</label>
                <VehicleList
                  value={this.state.vehicle_number}
                  handleDropdownChange={this.handleVehicleChange}
                  selectedCustomerId={this.state.customer_id}
                />
              </div>
              <div className="filter-group with-icon">
                <label>
                  Results to display- {this.state.limit || 20} (Total:{' '}
                  {this.state.count})
                </label>
                <form onSubmit={this.handleQuickSearch}>
                  <input type="text" name="limit" ref={this.limitInput} />
                  <button
                    type="submit"
                    className="search-icon"
                    onClick={this.handleQuickSearch}
                  />
                </form>
              </div>
              <div className="filter-group reset-filter">
                <button onClick={this.resetFilter}>Reset filters</button>
              </div>
              <div className="filter-group">
                <button
                  className="submit"
                  type="submit"
                  onClick={this.submitForm}
                >
                  Apply filter
                </button>
              </div>
            </div>
          </div>
          <div className="table-wrapper">
            <div className="mini-summary">
              <ul>
                <li>
                  <span> Total outstanding amount: </span>
                  <span>
                    {new Intl.NumberFormat('en-IN', {}).format(
                      parseFloat(slipList[0]?.balance).toFixed(2) || 0,
                    )}
                  </span>
                </li>
              </ul>
            </div>
            {(() => {
              if (this.state.loading) {
                return <DropLoaderLarge />;
              } else {
                return (
                  <TableGrid
                    col={col}
                    row={slipList}
                    offset={this.state.offset}
                    count={this.state.count}
                    limit={this.state.limit}
                    handlePagination={this.handlePagination}
                    hideActions={true}
                    exportOptions={{
                      fileName: `Credit Ledger - ${this.state.start_date} to ${this.state.end_date}.pdf`,
                      reportName: 'Credit Ledger Report',
                      reportDate: `Date - ${dayjs(this.state.start_date).format(
                        'D MMM YY',
                      )} to ${dayjs(this.state.end_date).format('D MMM YY')}`,
                      reportTotal: `Total outstanding amount -  ${
                        parseFloat(slipList[0]?.balance).toFixed(2) || 0
                      }`,
                      reportQuantity: '',
                      reportSales: '',
                      reportTesting: '',
                      reportBowser: '',
                      reportCustomerName: '',
                      reportGst: '',
                      reportOpeningBalance: '',
                      reportClosingBalance: '',
                    }}
                  />
                );
              }
            })()}
          </div>
        </main>
      </section>
    );
  }
}

export { CreditLedger };
